import { useState } from "react";
import { PhotoProvider, PhotoView } from "react-photo-view";

import { Refresh, ZoomIn, ZoomOut } from "@mui/icons-material";

const controlStyle = {
	fontSize: "44px",
	transition: "opacity 200ms linear",
};

export const SingleImageViewer = ({ getSrcData, children }) => {
	const [srcData, setSrcData] = useState("");

	const onVisibleChange = (visible) => {
		if (visible) {
			getSrcData().then((src) => {
				if (src) {
					setSrcData(src);
				}
			});
		}
	};

	return (
		<PhotoProvider
			onVisibleChange={onVisibleChange}
			toolbarRender={({ scale, onScale, rotate, onRotate }) => {
				return (
					<>
						<ZoomIn className="PhotoView-Slider__toolbarIcon" sx={controlStyle} onClick={() => onScale(scale + 1)} />
						<ZoomOut className="PhotoView-Slider__toolbarIcon" sx={controlStyle} onClick={() => onScale(scale - 1)} />
						<Refresh className="PhotoView-Slider__toolbarIcon" sx={controlStyle} onClick={() => onRotate(rotate + 90)} />
					</>
				);
			}}
		>
			<PhotoView src={srcData}>{children}</PhotoView>
		</PhotoProvider>
	);
};
